import { UserDetails } from '@fiverr-private/homepage_common_types';
import { getContext } from '@fiverr-private/fiverr_context';
import { JobFullData, LazyJobsTbdSdk, isLazySDK } from '@fiverr-private/jtbd_sdk';
import { IdentifiedEagerJobInfo, IdentifiedJobInfo, isJobWithDismissInfo } from '../../../lib/interfaces/jobsTBD';
import { JobsTbdMapper } from '../../../lib/utils/jobsTBDMapper';

interface LoadDataFunctions {
    loadData: () => ReturnType<LazyJobsTbdSdk['loadJobData']>;
    loadFallbackData: () => ReturnType<LazyJobsTbdSdk['loadFallbackJobData']>;
}

export const getLoadDataFunctions = (
    jobInitialData: IdentifiedJobInfo,
    userContext: Partial<UserDetails>,
    rollouts: Record<string, boolean>
): LoadDataFunctions => {
    const jobSDKImpl = JobsTbdMapper[jobInitialData.jobType];

    if (isLazySDK(jobSDKImpl)) {
        const loadFnArgs = {
            context: getContext(),
            buyerInsights: userContext.buyerInsights as UserDetails['buyerInsights'],
            userData: userContext.userData as UserDetails['userData'],
            rollouts,
            jtbdDismissInfo: isJobWithDismissInfo(jobInitialData) ? jobInitialData.jobDismissInfo : undefined,
        };

        return {
            loadData: () => jobSDKImpl.loadJobData(loadFnArgs),
            loadFallbackData: () => jobSDKImpl.loadFallbackJobData(loadFnArgs),
        };
    } else {
        const { jobInfo } = jobInitialData as IdentifiedEagerJobInfo;
        const { shouldDisplayJob: _shouldDisplayJob, ...jobSSRData } = jobInfo;
        const cardCallbacks = jobSDKImpl.cardCallbacks;

        const jobCard: JobFullData = {
            ...jobSSRData,
            ...cardCallbacks,
        };

        return {
            loadData: () => Promise.resolve(jobCard),
            loadFallbackData: () => jobCard,
        };
    }
};
